import React, { Dispatch, useEffect, useState } from "react"
import { Button, Modal, Row, Col, Switch, Slider, Select } from "antd"
import { updateSettings } from "../../api/CameraSettings/cameraSettings";
import { updateThreshold } from '../../api/Threshold/Threshold';

const { Option } = Select

const RATIO: { width: number, height: number, resolution: string }[] = [
  { width: 640, height: 480, resolution: "480p" },
  { width: 1280, height: 720, resolution: "720p" },
  { width: 1920, height: 1080, resolution: "1080p" },
  { width: 2560, height: 1440, resolution: "1440p" },
  { width: 3840, height: 2160, resolution: '2160p' }
]

const Settings = (props: {
  setSettingsModal: Dispatch<boolean>, settingsModal: boolean, setAuto: Dispatch<boolean>, auto: boolean,
  setSlider: Dispatch<number>, slider: number, calibrate: any, _color: number[], setDeviceId: Dispatch<number>, deviceId: number, devices,
  setIsPhotoOnly: Dispatch<boolean>, isPhotoOnly: boolean, setRefresh: Dispatch<boolean>, refresh: boolean,
  resolution: { width: number, height: number, resolution: string } | undefined, setResolution: Dispatch<{ width: number, height: number, resolution: string }>,
  setDebugScan: Dispatch<boolean>, debugScan: boolean,
  setUploadViaBackend: Dispatch<boolean>, uploadViaBackend: boolean
}) => {
  const { setSettingsModal, settingsModal, setAuto, auto, setSlider, slider, calibrate, _color, setDeviceId, deviceId, devices, setIsPhotoOnly, isPhotoOnly,
    setRefresh, refresh, resolution, setResolution, setDebugScan, debugScan, setUploadViaBackend, uploadViaBackend } = props
  const [isTest, setTest] = useState<boolean>(false)

  const update = async (i: number, bool: boolean, photo: boolean, isRefresh,
    resolution: { width: number, height: number, resolution: string } | undefined, uploadBackend: boolean = uploadViaBackend) => {
    await updateSettings(devices[i].deviceId, bool, photo, isRefresh, resolution ?? { width: 3840, height: 2160, resolution: '2160p' }, uploadBackend)
  }

  useEffect(() => {
    const test = localStorage.getItem("isTest")
    if (test) {
      setTest(test === "true")
    }
  }, [])

  async function maxResolution() {

  }

  return (
    <Modal
      zIndex={500}
      key={"settings"}
      title={"Paramètres avancé de camera et détéction"}
      open={settingsModal}
      onCancel={() => setSettingsModal(false)}
      footer={[
        <Button key={"back"} onClick={() => setSettingsModal(false)}>Retour</Button>
      ]}
    >
      <Row>
        <Col xs={24} md={10} >
          <span>Selectionner une caméra:</span>
        </Col>
        <Col xs={24} md={14}>
          <Select size="small" value={deviceId} onChange={(e) => {
            setDeviceId(e)
            update(e, auto, isPhotoOnly, refresh, resolution)
          }} style={{ width: "100%" }} defaultValue={0}>
            {devices && devices.map((device: any, index) => (
              <Option value={index} key={index}> {device.label || `Device ${index + 1}`}</Option>
            ))}
          </Select>
        </Col>
        <Col xs={24} md={10} style={{ paddingTop: "1rem" }}>
          Prise de photo seul:
        </Col>
        <Col xs={24} md={14} style={{ paddingTop: "1rem" }}>
          <Switch checked={isPhotoOnly} onChange={(e) => { setIsPhotoOnly(e); update(deviceId, auto, e, refresh, resolution) }} />
        </Col>
        <Col xs={24} md={10} style={{ paddingTop: "1rem" }}>
          Reconnaisance plateau:
        </Col>
        <Col xs={24} md={14} style={{ paddingTop: "1rem" }}>
          <Switch checked={auto} defaultChecked onChange={(e) => {
            setAuto(e)
            update(deviceId, e, isPhotoOnly, refresh, undefined)
          }} />
        </Col>
        <Col xs={24} md={10} style={{ paddingTop: "0.5rem" }}>
          <span>
            Seuil
          </span>
        </Col>
        <Col md={14} xs={24} style={{ paddingTop: "0.5rem" }}>
          <Slider tooltip={{
            getPopupContainer: () => {
              let container = document.querySelector("body > div:nth-child(2) > div > div.ant-modal-wrap")
              if (container !== null) return container as HTMLElement
              return document.body
            }
          }} style={{ width: '90%', display: 'inline-block' }} max={2} step={0.1} onChange={(e) => setSlider(e)} onAfterChange={(e) => updateThreshold(e)} defaultValue={slider} value={slider} />
        </Col>
        <Col xs={24} md={10}>
          <span>Couleur</span>
        </Col>
        <Col xs={24} md={14}>
          <div style={{ backgroundColor: "rgba(" + _color.join(",") + ')', width: '1rem', height: "1rem", display: 'inline-block', marginLeft: "1rem", marginRight: "1rem" }} />
          <Button onClick={() => calibrate()}>Recalibrer</Button>
        </Col>
        <Col xs={24} md={10}>
          <span>Résolution</span>
        </Col>
        <Col xs={24} md={14}>
          <Select size="small" value={resolution?.resolution ?? "2160p"} onChange={(e) => {
            const elem = RATIO.find((elem) => elem.resolution === e)
            if (elem) {
              setResolution(elem)
              update(deviceId, auto, isPhotoOnly, refresh, elem)
            }
          }}>
            {RATIO.map((elem, index) => (
              <Option disabled={false} value={elem.resolution} key={index}>{`${elem.resolution} - ${elem.width}x${elem.height}`}</Option>
            ))}
          </Select>
        </Col>
        <Col xs={24} md={10} style={{ paddingTop: "0.5rem" }}>
          <span>Envoi des photos via le serveur</span>
        </Col>
        <Col xs={24} md={14} style={{ paddingTop: "0.5rem" }}>
          <Switch checked={uploadViaBackend} onChange={(e) => {
            setUploadViaBackend(e)
            update(deviceId, auto, isPhotoOnly, refresh, resolution, e)
          }} />
          <div style={{ color: "grey", fontSize: "0.75rem" }}>
            Les photos transitent par le serveur Datakeen au lieu d'être envoyées directement à Amazon S3 depuis le navigateur.
          </div>
        </Col>
        {/* <Col xs={24} md={10} style={{ paddingTop: "0.5rem" }}>
          Rafraichir la page
        </Col>
        <Col xs={24} md={14} style={{ paddingTop: "0.5rem" }}>
          <Switch checked={refresh} onChange={(e) => {
            if (!e) {
              sessionStorage.removeItem("error")
              sessionStorage.removeItem("take_photo")
              sessionStorage.removeItem("result")
            }
            setRefresh(e)
            update(deviceId, auto, isPhotoOnly, e)
          }} />
        </Col> */}
        {(window.location.host === "hiris-dev.datakeen.co" || window.location.host === "hiris.staging.datakeen.co" || window.location.host === "localhost:3000") &&
          <>
            <Col xs={24} md={10} style={{ paddingTop: "0.5rem" }}>
              Mode test
            </Col>
            <Col xs={24} md={14} style={{ paddingTop: "0.5rem" }}>
              <Switch checked={isTest} onChange={(e) => {
                setTest(e)
                localStorage.setItem("isTest", e.toString())
              }} />
            </Col>
            <Col xs={24} md={10} style={{ paddingTop: "0.5rem" }}>
              Scan continu (Debug)
            </Col>
            <Col xs={24} md={14} style={{ paddingTop: "0.5rem" }}>
              <Switch checked={debugScan} onChange={(e) => {
                setDebugScan(e)
              }} />
            </Col>
          </>
        }
        <Col>
        </Col>
      </Row>
    </Modal >
  )
}

export default Settings